// @flow
import React from "react";

export class ContactUs extends React.Component {
  render() {
    const rootContainerStyle = {
      backgroundImage: 'url("/arts-build.jpg")',
      color: "red",
      height: "100vh",
      width: "100vw"
    };

    return (
      <div style={rootContainerStyle}>
        <div style={{
          width: '50%',
          margin: '0 auto',
        }}>ContactUs</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ContactUs.js